import { Button as BaseButton } from '@base-ui/react/button'
import type { ComponentProps } from 'react'
import { CHIP_VARIANT_CLASS, type ChipVariant } from './chip-badge'
import baseStyles from './chip-base.module.css'
import styles from './chip-badge.module.css'
import { TONE_CLASS } from './tones'
import type { ActionTone } from './tones'

/**
 * El `className` de Base UI puede ser una función del estado, no solo un string — de ahí el tipo
 * prestado en vez de un `string`. Es el mismo trato que le da `button.tsx`.
 */
export type ChipControlClassName = ComponentProps<typeof BaseButton>['className']

/**
 * La receta de clases de un chip que **es un control**: la geometría y el color son los del `Chip`,
 * y esto suma la capa de interacción —hover, foco, estado.
 *
 * Vive acá y no en `chip-button.tsx` por lo mismo que `chip-badge.ts`: la comparten tres
 * componentes —`ChipButton`, `ChipLink` y el `Toggle` con `look="chip"`— y una función al lado de
 * un componente le rompe el fast-refresh (`react-refresh/only-export-components`).
 *
 * `extra` son las clases que el componente agrega, y va **antes** del `className` del call site
 * aunque se declare después: el orden del array es el que importa, y lo que pasa el consumidor va
 * último para que pueda pisar. El `Toggle` lo usa para su clase marcadora.
 */
export function chipControlClasses(
  tone: ActionTone,
  variant: ChipVariant,
  className?: ChipControlClassName,
  extra?: string,
) {
  return [
    baseStyles['au-chip'],
    styles['au-chip-control'],
    'au-focusable',
    TONE_CLASS[tone],
    CHIP_VARIANT_CLASS[variant],
    extra,
    className,
  ]
    .filter(Boolean)
    .join(' ')
}
